
import { useEffect, useState } from "react";
import { setPage, setToolbarActions, setToolbarComponent, useEnsureJobs, useGlobal } from "../../../../core/Global";
import JobsBoardActions from "../components/JobsBoardActions";
import { useRememberJobsBoard } from "../utils/jobsBoardState";
import JobsFilterBar from "../components/JobsFilterBar";
import Layout from "../../../../components/layouts/Layout";
import Section from "../../../../components/base/Section";
import JobsCalendar, { CalendarDateBasis } from "../../../../components/calendar/JobsCalendar";
import Indicator from "../../../../components/base/Indicator";
import Job from "../models/Job";


export default function JobsCalendarView() {

    const [globalState] = useGlobal()

    useEnsureJobs()
    useRememberJobsBoard()

    // The header's applied filters, as one predicate (see utils/jobFilters).
    const [boardFilter, boardFilterSet] = useState<(job: Job) => boolean>();
    const [findKeyword, findKeywordSet] = useState<string | undefined>();
    const [dateBasis, dateBasisSet] = useState<CalendarDateBasis>("appointment");

    const JobsGrouping = () => (
        <JobsFilterBar
            mode="calendar"
            onViewByChange={id => dateBasisSet(id)}
            onKeywordChange={findKeywordSet}
            onFilterChange={f => boardFilterSet(() => f)}
        />
    )

    useEffect(() => {

        setToolbarComponent(JobsGrouping)
        setToolbarActions(() => <JobsBoardActions />)
        setPage("Calendar", "CRM", "Jobs")

        return () => {
            setToolbarComponent(undefined)
            setToolbarActions(undefined)
        }

    }, [])

    return (
        <Layout wide>
            <Section fluid>

                {
                    !globalState.jobsFetched ?
                        <Section fluid>
                            <div className="text-center my-20">
                                <Indicator />
                            </div>
                        </Section>
                        : <JobsCalendar
                            filter={boardFilter}
                            findKeyword={findKeyword}
                            dateBasis={dateBasis} />
                }

            </Section>
        </Layout>
    )
}
